/**
 * 线上环境
 */
export const ONLINEHOST = 'http://hygl.beijingfire.com/index.php'
// export const ONLINEHOST = 'http://beijingfire.emof.cn/index.php'

/**
 * 测试环境
 */
// export const QAHOST = 'http://hygl.beijingfire.com/index.php'
export const QAHOST = 'http://192.168.2.143:8082/index.php'
// export const QAHOST = 'http://beijingfire.emof.cn/index.php'


/**
 * 上传下载
 */
export const UDHOST = process.env.NODE_ENV === 'production' ? ONLINEHOST : QAHOST
// export const UDHOST = 'http://hygl.beijingfire.com/index.php'

/**
 * 文件预览
 */
export const SHOWHOST = process.env.NODE_ENV === 'production' ? 'http://hygl.beijingfire.com' : 'http://hygl.beijingfire.com'
// export const SHOWHOST = process.env.NODE_ENV === 'production' ? 'http://beijingfire.emof.cn' : 'http://beijingfire.emof.cn'



/*
 * 缓存字段
 * */
export const localAnStore = [{
        key: 'user',
        type: 'localStorage'
    },
    {
        key: 'token',
        type: 'localStorage'
    }
]
